module.exports = __webpack_public_path__ + "img/DSC_0041.dd91d6d4.jpg";